import angular from 'angular';

const module = angular.module('whyline.directives.lettersOnly', []);

const lettersOnly = () => {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attr, ngModelCtrl) {
      function fromUser(text) {
        var transformedInput = text.replace(/[^a-zA-Z\s]/g, '');
        if (transformedInput !== text) {
          ngModelCtrl.$setViewValue(transformedInput);
          ngModelCtrl.$render();
        }
        return transformedInput;
      }
      ngModelCtrl.$parsers.push(fromUser);
    }
  };
};

module.exports = module.directive('lettersOnly', lettersOnly);
